export type Currency = 'USD';
export type Localization = 'en-us';

interface FormatCurrencyOptions {
  currency?: Currency;
  localization?: 'en-us';
}

type CurrencyValue = string | number;

export const convertStringToNumber = (value: string): number => {
  return Number((value || '0').replace(/[^0-9.-]+/g, ''));
};

export const formatCurrency = (
  value: CurrencyValue,
  { currency = 'USD', localization = 'en-us' }: FormatCurrencyOptions = {
    currency: 'USD',
    localization: 'en-us',
  }
): string => {
  const typedNumber = typeof value === 'string' ? convertStringToNumber(value) : value ?? 0;

  return typedNumber.toLocaleString(localization, {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  }) as string;
};
